module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgBvZGxDcMgEEUP5MJsgTdINnBGyARxOtpsEI9BxwgZIRvEG8AGSUkFuZMhshQSmcZfOjjp/yfdAVNK9QAgoU6uwWPAOkGdDM8N1rgCGBljN2oy2Ce4izFOBeBOHmXQ3y1BiWVpZK31Hu8zlsPQK4Rwadv2CPM6NmU/YNYVH8si8MT+IIToOOeT9/5B3jLYFMaSaQ+DAIMfD1cCs4Y/3teoq7U9SDsamP+pRu4NP2cw6lE+nXkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/adminRegister/assets/Vector (1).png
// module id = jsL1
// module chunks = 1